<div class="nec-container d-flex flex-column">
  <header class="d-flex justify-content-between align-items-center">
    <h3>Entity Class Instantiation</h3>
    <div class="d-flex">
      <div class="actions-div">
        <button class="btn-add first d-flex align-items-center gap-2"
          (click)="quickActionMenuOpened = !quickActionMenuOpened">
          Quick Action
          <img width="16" height="16" src="../../../assets/icons/arrow-down-small.svg" />
        </button>
        <div class="qa-menu" *ngIf="quickActionMenuOpened">
          <ul class="d-flex flex-column">
            <li data-bs-toggle="modal" [attr.data-bs-target]="'#uploadModal'" (click)="onUpload()">Upload with XLSX</li>
            <li (click)="onDownload()">Download</li>
            <li *ngIf="showFeederBandUpdate" data-bs-toggle="modal" [attr.data-bs-target]="'#uploadModal'" (click)="onFeederBandUpload()">Feeder Band Update</li>
            <li *ngIf="showFeederReassignment" data-bs-toggle="modal" [attr.data-bs-target]="'#uploadModal'" (click)="onFeederReassignment()">Feeder Reassignment</li>
            <li *ngIf="activeItemId == 0 || activeItemId == 1" data-bs-toggle="modal" [attr.data-bs-target]="'#uploadModal'" (click)="onUpdate()">Bulk Update</li>
          </ul>
        </div>
      </div>
      <button *ngIf="permissionsService.isNetworkEntityClassesCreateEditAllowed && canAddNewInstance" class="btn-add" [attr.data-bs-toggle]="getModalTarget() ? 'modal' : null" [attr.data-bs-target]="getModalTarget()"
        (click)="onAddNewClicked()">Add New Instance</button>
    </div>
  </header>

  <div class="nec-body d-flex">
    <div class="nec-sidebar">
      <ul>
        <ng-container *ngFor="let item of items">
          <li [class.active]="activeItemId === item.id" (click)="setActive(item.id)">
            {{ item.name }}
          </li>

          <div *ngIf="item.id === 5" style="width: 100%; background-color: #e4e4e4; height: 1px; margin: 0.75rem 0;">
          </div>
        </ng-container>
      </ul>
    </div>

    <main class="nec-content-container flex-grow-1 d-flex flex-column">
      <lib-nec-substation *ngIf="activeItemId === 0" #necSubstationComponent
        [pendingSubstationToOpen]="pendingSubstationToOpen"
        (pendingSubstationHandled)="onPendingSubstationHandled()">
      </lib-nec-substation>
      <lib-nec-ac-line-segment *ngIf="activeItemId === 1" (editModal)="handleEditModal($event)"
        #necAcLineSegmentComponent>
      </lib-nec-ac-line-segment>
      <lib-nec-power-transformer *ngIf="activeItemId === 2" #necPowerTransformerComponent
        (openSubstationSchematic)="onOpenSubstationSchematic($event)">
      </lib-nec-power-transformer>
      <lib-nec-connector-switch-container [type]="'connector'" *ngIf="activeItemId === 3"
        #necConnectorContainerComponent
        (openSubstationSchematic)="onOpenSubstationSchematic($event)">
      </lib-nec-connector-switch-container>
      <lib-nec-connector-switch-container [type]="'switch'" *ngIf="activeItemId === 4" #necSwitchContainerComponent
        (openSubstationSchematic)="onOpenSubstationSchematic($event)">
      </lib-nec-connector-switch-container>

      <lib-nec-connector-switch-container [type]="'groundingAndSectioning'" *ngIf="activeItemId === 18"
        #necGroundingAndSectioningContainerComponent
        (openSubstationSchematic)="onOpenSubstationSchematic($event)">
      </lib-nec-connector-switch-container>
      <lib-nec-connector-switch-container [type]="'protectionDevices'" *ngIf="activeItemId === 19"
        #necProtectionDevicesContainerComponent
        (openSubstationSchematic)="onOpenSubstationSchematic($event)">
      </lib-nec-connector-switch-container>
      <lib-nec-connector-switch-container [type]="'compensationEquipment'" *ngIf="activeItemId === 20"
        #necCompensationEquipmentContainerComponent
        (openSubstationSchematic)="onOpenSubstationSchematic($event)">
      </lib-nec-connector-switch-container>

      <lib-nec-base-voltage *ngIf="activeItemId === 5" #necBaseVoltageComponent>
      </lib-nec-base-voltage>
      <lib-nec-district *ngIf="activeItemId === 6" #necDistrictComponent>
      </lib-nec-district>
      <lib-nec-region *ngIf="activeItemId === 7" #necRegionComponent>
      </lib-nec-region>
      <lib-nec-transformer-rating *ngIf="activeItemId === 10" #necTransformerRatingComponent>
      </lib-nec-transformer-rating>
    </main>
  </div>
</div>